<mat-card class="obg-m-zhh-session-limit-container">
	<div class="obg-m-zhh-session-limit-header">
		<div>
			<h1>{{ 'multi-session-limit.title' | translate }}</h1>
			<p>{{ 'multi-session-limit.description' | translate }}</p>
		</div>
	</div>

	<div class="obg-m-zhh-session-limit-current-amount">
		<h3>{{ 'multi-session-limit.current-limit' | translate }}</h3>
		<div *ngIf="(sessionLimits$ | async) as sessionLimits">
			<div
				*ngIf="sessionLimits.sessionLimitInfoResponse.hasSessionTimeLimit && millisecondsToHours(sessionLimits.sessionLimitInfoResponse.sessionTimeLimit) < MAX_DAILY_SESSION_LIMIT_VALUE; else noSessionLimit"
			>
				<span class="obg-m-zhh-session-limit-spent"
					>{{ getHoursAndMinutesFromMillis(sessionLimits.sessionLimitInfoResponse.usedSessionTimeLimit)
					}}</span
				>
				<span
					[innerHTML]="'multi-session-limit.session-status-total' | translate:
					{ sessionLimitString: getHoursAndMinutesFromMillis(sessionLimits.sessionLimitInfoResponse.sessionTimeLimit) }"
				>
				</span>
			</div>

			<ng-template #noSessionLimit>
				<label
					*ngIf="showSkipButton"
					[innerHtml]="'multi-session-limit.undefined' | translate"
					test-id="active-session-limit-undefined"
				></label>
				<label
					*ngIf="!showSkipButton"
					[innerHtml]="'multi-session-limit.not-set' | translate"
					test-id="active-session-limit-none"
				></label>
			</ng-template>
		</div>
	</div>

	<form [formGroup]="sessionLimitFormGroup" #formDirective="ngForm">
		<div class="obg-m-zhh-session-limit-form-container">
			<div class="obg-m-zhh-session-limit-input-container">
				<mat-form-field floatLabel="always">
					<mat-label>{{ 'multi-session-limit.label' | translate }}</mat-label>
					<input
						matInput
						type="tel"
						[placeholder]="placeholder | translate"
						formControlName="limit"
						obgNumericNotZero
						required
					/>
					<mat-icon class="ico-checkmark form-field-icon" matSuffix></mat-icon>
				</mat-form-field>

				<obg-common-validation-renderer
					[input]="sessionLimitFormGroup.controls.limit"
					[translationPrefix]="'multi-session-limit.daily'"
				>
				</obg-common-validation-renderer>
				<obg-input-information
					*ngIf="inputInformation && (sessionLimitFormGroup.valid || sessionLimitFormGroup.untouched)"
					[informationMessage]="inputInformation | translate: {
											queuedLimit: upcomingSessionLimit?.dailySessionLimit,
											activeFrom: upcomingSessionLimit?.activeFrom | date: 'short'}"
				>
				</obg-input-information>
			</div>

			<mat-spinner *ngIf="isSettingBusy" diameter="20"></mat-spinner>
			<div class="obg-m-zhh-session-limit-form-buttons-container" *ngIf="!isSettingBusy">
				<button
					mat-flat-button
					color="accent"
					[disabled]="sessionLimitFormGroup.pristine || sessionLimitFormGroup.invalid"
					(click)="submitSessionLimit('Set')"
				>
					{{ 'multi-session-limit.set' | translate }}
				</button>
				<button mat-flat-button color="accent" (click)="setSessionLimit(null)" *ngIf="showSkipButton">
					{{ 'multi-session-limit.skip' | translate }}
				</button>
				<button
					mat-flat-button
					color="primary"
					*ngIf="upcomingSessionLimit"
					(click)="submitSessionLimit('Undo')"
				>
					{{ 'multi-session-limit.undo' | translate }}
				</button>
				<button
					mat-flat-button
					color="primary"
					*ngIf="isLimitSet && !upcomingSessionLimit && !showSkipButton"
					[disabled]="!sessionLimitFormGroup.pristine && sessionLimitFormGroup.invalid"
					(click)="submitSessionLimit('Remove')"
				>
					{{ 'multi-session-limit.remove' | translate }}
				</button>
			</div>
		</div>
	</form>

	<span (click)="toggleInfoVisibility()" class="zhh-session-limit-more-info-button"
		>{{ (isInfoVisible? 'general.read-less' : 'general.read-more') | translate }}</span
	>
	<ng-container *ngIf="isInfoVisible">
		<div class="caption" [innerHtml]="'multi-session-limit.caption' | jurisdiction | translate"></div>
	</ng-container>
</mat-card>
